import Auth from "./components/AuthComponent";
import Admin from "./components/AdminComponent";

import Wrapper from "./pages/Wrapper";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Forgot from "./pages/auth/Forgot";
import Reset from "./pages/auth/Reset";

import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Data from "./pages/Data";

import Home from "./pages/Home";
import Notifications from "./pages/Notifications";
import Services from "./pages/Services";
import Service from "./pages/Service";
import ServiceView from "./pages/ServiceView";
import Payments from "./pages/Payments";
import PaymentView from "./pages/PaymentView";
import Ticket from "./pages/Ticket";
import Tickets from "./pages/Tickets";
import TicketView from "./pages/TicketView";
import About from "./pages/About";
import Rewards from "./pages/Rewards";
import Help from "./pages/Help";
import Profile from "./pages/Profile";
import ProfileView from "./pages/ProfileView";
import Password from "./pages/Password";
import NotFound from "./pages/404";

import VPending from "./pages/admin/checker/Pending";
import VApproved from "./pages/admin/checker/Approved";
import VRejected from "./pages/admin/checker/Rejected";
import VAbandoned from "./pages/admin/checker/Abandoned";

import TPending from "./pages/admin/process/Pending";
import TCompleted from "./pages/admin/process/Completed";
import TAssigned from "./pages/admin/process/Assigned";

import CPending from "./pages/admin/support/Pending";
import CResponded from "./pages/admin/support/Responded";
import CClosed from "./pages/admin/support/Closed";

import Collect from "./pages/admin/cashier/Collect";
import InOut from "./pages/admin/cashier/InOut";
import Exchange from "./pages/admin/cashier/Exchange";
import CsPending from "./pages/admin/cashier/Pending";
import Balance from "./pages/admin/cashier/Balance";
import Movements from "./pages/admin/cashier/Movements";

import Accounts from "./pages/admin/accounting/Accounts";
import BankMovements from "./pages/admin/accounting/Movements";
import BankTransfer from "./pages/admin/accounting/Transfer";
import AcInOut from "./pages/admin/accounting/InOut";

import General from "./pages/admin/auditor/General";
import Completed from "./pages/admin/auditor/Completed";
import ReportOffices from "./pages/admin/auditor/Offices";

import Customers from "./pages/admin/settings/Customers";
import Staff from "./pages/admin/settings/Staff";

import configAds from "./pages/admin/settings/Ads";
import configLegal from "./pages/admin/settings/Legal";
import configRate from "./pages/admin/settings/Rate";
import configGateways from "./pages/admin/settings/Gateways";
import configAccounts from "./pages/admin/settings/Accounts";
import configOffices from "./pages/admin/settings/Offices";
import configLimits from "./pages/admin/settings/Limits";
import configFee from "./pages/admin/settings/Fee";

export default [
    ...applyRules(['guest'], [
        { path: '', component: Auth, redirect: { name: 'Login' }, children:
            [
                { path: '/login', name: 'Login', component: Login, meta: { title: 'Inicio' } },
                { path: '/register', name: 'Register', component: Register, meta: { title: 'Crear Cuenta' } },
                { path: '/password', component: Wrapper, children:
                    [
                        { path: 'reset', name: 'Forgot', component: Forgot, meta: { title: 'Recuperar Contraseña' } },
                        { path: 'reset/:token', name: 'Reset', component: Reset, meta: { title: 'Cambiar Contraseña' } }
                    ]
                }
            ]
        },
    ]),
    ...applyRules(['auth'], [
        { path: '', component: Admin, redirect: { name: 'Home' }, children:
            [
                { path: '/', name: 'Home', component: Home, meta: { title: 'Inicio' } },
                { path: '/notifications', name: 'Notifications', component: Notifications, meta: { title: 'Notificaciones' } },
                { path: '/services', name: 'Services', component: Services, meta: { title: 'Servicios' } },
                { path: '/services/new', name: 'Service', component: Service, meta: { title: 'Solicitud de Servicio' } },
                { path: '/services/:id', name: 'ServiceView', component: ServiceView, meta: { title: 'Detalle del Servicio' } },
                { path: '/payments', name: 'Payments', component: Payments, meta: { title: 'Pagos' } },
                { path: '/payments/:id', name: 'PaymentView', component: PaymentView, meta: { title: 'Detalles de Pago' } },
                { path: '/tickets', name: 'Tickets', component: Tickets, meta: { title: 'Tickets' } },
                { path: '/tickets/new', name: 'Ticket', component: Ticket, meta: { title: 'Crear Ticket' } },
                { path: '/tickets/:id', name: 'TicketView', component: TicketView, meta: { title: 'Detalles del Ticket' } },
                { path: '/rewards', name: 'Rewards', component: Rewards, meta: { title: 'Recompensas' } },
                { path: '/profile', name: 'ProfileView', component: ProfileView, meta: { title: 'Mi Perfil' } },
                { path: '/profile/edit', name: 'Profile', component: Profile, meta: { title: 'Editar Perfil' } },
                { path: '/profile/password', name: 'Password', component: Password, meta: { title: 'Cambiar Contraseña' } },
                { path: '/profile/about', name: 'About', component: About, meta: { title: 'Sobre Nosotros' } },
                { path: '/profile/terms', name: 'TermsView', component: Terms, meta: { title: 'Términos & Condiciones' } },
                { path: '/profile/privacy', name: 'PrivacyView', component: Privacy, meta: { title: 'Política de Privacidad' } },
                { path: '/profile/cookies', name: 'CookiesView', component: Cookies, meta: { title: 'Política de Cookies' } },
                { path: '/profile/data', name: 'DataView', component: Data, meta: { title: 'Política de Tratamiento de Datos' } },
                { path: '/profile/help', name: 'Help', component: Help, meta: { title: 'Ayuda' } },

                { path: '/checker/pending', name: 'VPending', component: VPending, meta: { title: 'Pendientes' } },
                { path: '/checker/approved', name: 'VApproved', component: VApproved, meta: { title: 'Aprobadas' } },
                { path: '/checker/rejected', name: 'VRejected', component: VRejected, meta: { title: 'Rechazadas' } },
                { path: '/checker/abandoned', name: 'VAbandoned', component: VAbandoned, meta: { title: 'Abandonadas' } },

                { path: '/process/pending', name: 'TPending', component: TPending, meta: { title: 'Pendientes' } },
                { path: '/process/assigned', name: 'TAssigned', component: TAssigned, meta: { title: 'Asignadas' } },
                { path: '/process/completed', name: 'TCompleted', component: TCompleted, meta: { title: 'Completadas' } },

                { path: '/support/pending', name: 'CPending', component: CPending, meta: { title: 'Reclamos Por Responder' } },
                { path: '/support/responded', name: 'CResponded', component: CResponded, meta: { title: 'Reclamos Respondidos' } },
                { path: '/support/closed', name: 'CClosed', component: CClosed, meta: { title: 'Reclamos Cerrados' } },

                { path: '/cashier/in', name: 'Collect', component: Collect, meta: { title: 'Pendientes por Cobrar' } },
                { path: '/cashier/out', name: 'CsPending', component: CsPending, meta: { title: 'Pagos Pendientes' } },
                { path: '/cashier/in-out', name: 'InOut', component: InOut, meta: { title: 'Entradas/Salidas' } },
                { path: '/cashier/exchange', name: 'Exchange', component: Exchange, meta: { title: 'Cambio de Divisas' } },
                { path: '/cashier/balance', name: 'Balance', component: Balance, meta: { title: 'Balance Actual' } },
                { path: '/cashier/movements', name: 'Movements', component: Movements, meta: { title: 'Movimientos' } },

                { path: '/movements/accounts', name: 'Accounts', component: Accounts, meta: { title: 'Cuentas Bancarias' } },
                { path: '/movements/accounts/:id', name: 'BankMovements', component: BankMovements, meta: { title: 'Movimientos Bancarios' } },
                { path: '/movements/transfer', name: 'BankTransfer', component: BankTransfer, meta: { title: 'Traslados' } },
                { path: '/movements/in-out', name: 'AcInOut', component: AcInOut, meta: { title: 'Entradas/Salidas' } },

                { path: '/reports/general', name: 'General', component: General, meta: { title: 'Reporte General' } },
                { path: '/reports/completed', name: 'Completed', component: Completed, meta: { title: 'Reporte Completadas' } },
                { path: '/reports/offices', name: 'ReportOffices', component: ReportOffices, meta: { title: 'Reporte de Oficinas' } },

                { path: '/users/customers', name: 'Customers', component: Customers, meta: { title: 'Listado de Clientes' } },
                { path: '/users/staff', name: 'Staff', component: Staff, meta: { title: 'Listado de Empleados' } },

                { path: '/settings/ads', name: 'configAds', component: configAds, meta: { title: 'Configurar Anuncios' } },
                { path: '/settings/legal', name: 'configLegal', component: configLegal, meta: { title: 'Configurar Información Legal' } },
                { path: '/settings/rate', name: 'configRate', component: configRate, meta: { title: 'Configurar Tasa de Cambio' } },
                { path: '/settings/gateways', name: 'configGateways', component: configGateways, meta: { title: 'Registro de Bancos' } },
                { path: '/settings/accounts', name: 'configAccounts', component: configAccounts, meta: { title: 'Registro de Cuentas' } },
                { path: '/settings/offices', name: 'configOffices', component: configOffices, meta: { title: 'Registro de Oficinas' } },
                { path: '/settings/limits', name: 'configLimits', component: configLimits, meta: { title: 'Configurar Montos Minimos' } },
                { path: '/settings/fee', name: 'configFee', component: configFee, meta: { title: 'Configurar Comisiones' } },
            ]
        }
    ]),
    { path: '', component: Auth, redirect: {name: 'Login'}, children:
        [
            { path: '/terms', name: 'Terms', component: Terms, meta: { title: 'Términos & Condiciones' } },
            { path: '/privacy', name: 'Privacy', component: Privacy, meta: { title: 'Política de Privacidad' } },
            { path: '/cookies', name: 'Cookies', component: Cookies, meta: { title: 'Política de Cookies' } },
            { path: '/data', name: 'Data', component: Data, meta: { title: 'Política de Tratamiento de Datos' } }
        ]
    },
    { path: '*', component: NotFound, meta: { title: 'Página no Encontrada' } }
];

function applyRules(rules, routes) {
    for (let i in routes) {
        routes[i].meta = routes[i].meta || {};

        if (!routes[i].meta.rules) {
            routes[i].meta.rules = [];
        }
        routes[i].meta.rules.unshift(...rules);

        if (routes[i].children) {
            routes[i].children = applyRules(rules, routes[i].children);
        }
    }

    return routes
}
